export const catalogConfigs = {
  title: {
    default: "E-catalog DT",
    ko: "전자카탈로그 DT",
  },
  langSet: ["ko", "en"],
  pageMap: [
    { name: "intro" },
    { name: "cover" },
    { name: "catalog-index" },
    {
      name: "technology",
      outlets: ["lorawan", "dt-tech", "why-dt"],
    },
    {
      name: "solution",
      outlets: [
        {
          name: "total-solution",
          outlets: [
            "cover",
            "lot-end-to-end",
            {
              name: "lot-total",
              outlets: [{ name: "gateway", outlets: ["1", "2"] }, "devices"],
            },
            "sensors",
            "network",
          ],
        },
        {
          name: "safety-solution",
          outlets: [
            "cover",
            "overview",
            {
              name: "landslide-system",
              outlets: [
                "smart-system",
                "smart-diagram",
                { name: "sensor-node", outlets: ["1", "2"] },
              ],
            },
            {
              name: "manhole-detection",
              outlets: ["system-feature", { name: "system-diagram", outlets: ["1", "2"] }],
            },
            {
              name: "monitoring-system",
              outlets: ["1", "2", "3", "4", "5", "6", "7"],
            },
          ],
        },
        {
          name: "city-solution",
          outlets: ["cover", "overview", "smart-system", "smart-monitoring"],
        },
        {
          name: "agriculture-solution",
          outlets: ["cover", "overview", "smart-system", "smart-diagram"],
        },
        {
          name: "mensuration-solution",
          outlets: ["cover", "overview", "smart-system"],
        },
        {
          name: "industry-solution",
          outlets: ["cover", "overview", "smart-system"],
        },
      ],
    },
    {
      name: "company",
      outlets: ["cover", "about-dt", "certification", "history", "partner"],
    },
    { name: "last" },
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 767,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
